<script setup lang="ts">
/**
 * App.vue · 应用根组件
 * ------------------------------------------------------------
 * M0 只负责把壳层套进去。业务内容由 router 分发。
 */
import AppShell from '@/shell/AppShell.vue'
import ThemeProvider from '@/shell/theme/ThemeProvider.vue'
import GlobalOverlay from '@/shell/overlay/GlobalOverlay.vue'
</script>

<template>
  <ThemeProvider>
    <AppShell />
    <GlobalOverlay />
  </ThemeProvider>
</template>
